import React from "react";
import Loadable from "react-loadable";
import { useSelector } from "react-redux";
import { EmptyComponent } from "../../../components/common/EmptyComponent";
import { AppFeatures } from "../../../constants/featureFlags";
import { useFeature } from "../../../hooks/useFeature";
import { UserContextSelectors } from "../../../redux/selectors";

export const useIsCasinoDailyWishAvailable = () => {
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);
  const isVip = useSelector(UserContextSelectors.isVip);
  const isPromotionPermitted = useSelector(
    UserContextSelectors.isPromotionPermitted
  );
  const isInCasinoDailyWishActive = useFeature(AppFeatures.CASINO_DAILY_WISH);

  return (
    isAuthenticated &&
    isPromotionPermitted &&
    !isVip &&
    isInCasinoDailyWishActive
  );
};

export const CasinoDailyWishChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "menu/casino-daily-wish" */
      "./CasinoDailyWish"
    ),
  render(loaded, props) {
    let Component = loaded.CasinoDailyWish;
    return <Component {...props} />;
  },
  loading: EmptyComponent
});
